import { Box, Flex, IconButton } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { booleanBodyRender, TableColumn } from '@app/components/common/table';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (route: EntityBase) => void;
}): TableColumn[] => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'name',
      label: 'Значение',
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          return (
            <Box whiteSpace="pre-wrap" style={{ wordBreak: 'break-all' }}>
              {value.toString()}
            </Box>
          );
        },
      },
    },
    {
      name: 'is_active',
      label: 'Активен',
      options: {
        filter: {
          type: 'boolean',
        },
        sort: true,
        customBodyRender: booleanBodyRender(),
      },
    },
    {
      name: 'id',
      label: 'Действия',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (id, { rowData }) => {
          return (
            <Flex gap={2}>
              <IconButton name="edit" onClick={() => onEdit(rowData)} aria-label="edit">
                <MdEdit />
              </IconButton>
            </Flex>
          );
        },
      },
    },
  ];
};
